import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeIn } from './ui/Section';
import { AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <Section dark className="bg-[#003366] relative overflow-hidden" data-id="element-253">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-254">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#FF6600] rounded-full blur-3xl" data-id="element-255" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-blue-500 rounded-full blur-3xl" data-id="element-256" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-257">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-258">
          <div className="inline-flex items-center justify-center p-3 bg-[#FF6600]/10 rounded-full mb-8" data-id="element-259">
            <AlertTriangle className="w-6 h-6 text-[#FF6600]" data-id="element-260" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-261">
            El dolor real <br data-id="element-262" />
            <span className="text-slate-300 text-2xl md:text-3xl font-normal" data-id="element-263">
              (lo que nadie dice en voz alta)
            </span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-264">
            <p data-id="element-265">El problema no es el vocabulario.</p>
            <p className="font-medium text-white" data-id="element-266">
              Es ese micro-segundo donde te hablan rápido, tú te quedas atrapado
              traduciendo, y te da vergüenza porque sientes que te ven
              "chiquito".
            </p>
            <p data-id="element-267">Ese momento hace que evites:</p>

            <div className="grid grid-cols-2 gap-4 py-8" data-id="element-268">
              {['Llamadas', 'Entrevistas', 'Pedir ayuda', 'Socializar'].map(item => <div key={item} className="bg-[#002244] p-4 rounded-lg border border-[#004488] text-white font-medium" data-id="element-269">
                    {item}
                  </div>)}
            </div>

            <p className="text-2xl font-bold text-white" data-id="element-270">
              Y tu mundo se hace más pequeño.
            </p>
          </div>
        </motion.div>
      </div>
    </Section>;
}